import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import BannerCategoryCreateScreen from './BannerCategoryCreateScreen'

function CollectionCreate() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Tạo mới bộ sưu tập')} isExist={false} />
        <BannerCategoryCreateScreen/>
    </div>
  )
}

export default CollectionCreate
